import { scrollToSection, scrollToSectionMobile } from "@lib/general.utils";
import { QuestionMarkCircleIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import useGeneralStore from "@/store/General/useGeneralStore";

const HeroComponent = () => {
    const [width, setWidth] = useState<number | null>(null);
    const { t, i18n } = useTranslation("common");
    const [direction, setDirection] = useState<any>("");
    useEffect(() => {
        if (i18n.language) {
            setDirection(i18n.language === "ar" ? "rtl" : "ltr");
        }
    }, [i18n.language]);
    function handleWindowSizeChange() {
        setWidth(window?.innerWidth);
    }
    useEffect(() => {
        if (window) {
            setWidth(window?.innerWidth);
            window.addEventListener("resize", handleWindowSizeChange);
            return () => {
                window.removeEventListener("resize", handleWindowSizeChange);
            };
        }
    }, []);
    const router = useRouter();
    const { Socials } = useGeneralStore((state) => state);
    return (
        <div
            style={{ direction: direction ? direction : "rtl" }}
            className="gap-5 grid grid-cols-1 pb-[6rem] md:pb-[2rem] md:grid-cols-2 px-[1.5rem]  w-full relative z-20 overflow-hidden"
        >
            <div
                data-aos="fade-left"
                className=" my-[1rem] md:my-[6rem] ml-0 md:ml-[2rem] text-primary flex items-start justify-center px-[1rem] md:px-[5rem] "
            >
                <div className="mb-[3rem] mt-[0rem] md:mt-[3rem]  relative z-20 ">
                    <div className="text-[2.5rem]  md:text-[3.5rem]">
                        {t("home.hero.title")}
                    </div>
                    <div className="font-normal text-[2.5rem] md:text-[2.5rem]">
                        {t("home.hero.subtitle-1")}{" "}
                        <span className="text-[#00B8FF]">
                            {t("home.hero.subtitle-2")}
                        </span>
                    </div>
                    <p className="text-black text-[1.0rem] md:text-[1.7rem] my-[1.5rem] font-thin w-[70%] md:w-full">
                        {t("home.hero.desc")}
                    </p>
                    <button
                        onClick={() => router.push("/sign")}
                        className="mt-[1rem] px-[4rem] py-[1rem] rounded-md bg-secondary normal-case text-[1rem] md:text-[1.5rem] font-[500] text-[white]"
                    >
                        {t("home.hero.signup")}
                    </button>
                    <a
                        href={`https://wa.me/${Socials?.partnerWhatsApp}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <div className="text-[1.5rem] text-[#00B8FF] mt-[1rem] flex items-center gap-[0.3rem]">
                            <QuestionMarkCircleIcon className="w-[1.5rem]" />
                            <p>{t("home.hero.help")}</p>
                        </div>
                    </a>
                </div>
                <Image
                    width={1000}
                    height={1000}
                    alt="hero"
                    className="w-[30rem] -bottom-[1rem] float-right right-[0rem]  object-contain absolute"
                    src="/icons/smoke-2.svg"
                />
            </div>
            <div className="hidden mt-[-3rem]  md:flex items-start justify-center relative">
                <Image
                    data-aos="fade-right"
                    data-aos-duration="700"
                    width={1000}
                    height={1000}
                    alt="hero"
                    className="h-[60rem] object-contain "
                    src="/home/hero.png"
                />
                <Image
                    data-aos="fade-right"
                    width={1000}
                    height={1000}
                    alt="hero"
                    className="w-[10rem] bottom-[8rem] left-[35rem] object-contain absolute"
                    src="/home/hero-ico-bg-1.svg"
                />
                <Image
                    data-aos="zoom-in"
                    width={1000}
                    height={1000}
                    alt="hero"
                    className="w-[8rem] bottom-[9rem] left-[36rem] object-contain absolute"
                    src="/home/hero-ico-1.svg"
                />
                <Image
                    width={1000}
                    height={1000}
                    alt="hero"
                    className="w-[40rem] bottom-[1rem] -left-[0rem] object-contain absolute"
                    src="/icons/smoke-1.svg"
                />
                <Image
                    data-aos="fade-left"
                    width={1000}
                    height={1000}
                    alt="hero"
                    className="w-[10rem] top-[17rem] left-[17rem] object-contain absolute"
                    src="/home/hero-ico-bg-2.svg"
                />
                <Image
                    data-aos="zoom-in"
                    width={1000}
                    height={1000}
                    alt="hero"
                    className="w-[10rem] top-[19rem] left-[17rem] object-contain absolute"
                    src="/home/hero-ico-2.svg"
                />
                <Image
                    width={1000}
                    height={1000}
                    alt="hero"
                    className="w-[8rem] bottom-[1rem] left-[2rem] object-contain absolute"
                    src="/icons/dots.svg"
                />
                <Image
                    width={1000}
                    height={1000}
                    alt="hero"
                    className="w-[8rem] top-[10rem] left-[15rem] object-contain absolute"
                    src="/icons/square-dots.svg"
                />
            </div>
        </div>
    );
};

export default HeroComponent;
